import { signInWithPhoneNumber } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { setOtpData } from "store/actions/Authentication/otp";
import { checkUserExistsApi } from "store/services/Authentication";
import { showToast } from "utils/showToast";
import { isValidPhoneNumber } from "libphonenumber-js";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { firebaseRecaptchaVerifier } from "utils";
import { auth } from "../../firebase";
import ConfirmationModal from "components/ConfirmationModal";
import { loginAlHalal, loginMav } from "assets/svgs";
import { MAVENCERY_STORES_NAMES } from "constants";
import CustomPhoneInput from "components/CustomPhoneInput";

const Login = ({ isSwapped, setIsSwapped }) => {
  const { selectedStore } = useSelector((store) => store.selectedStore);
  const { user } = useSelector((store) => store.userReducer);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const type = searchParams.get("type");

  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [appVerifier, setAppVerifier] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });

  const modalData = {
    title: "Account Not Found",
    body: "Seems like you are new here, Kindly signup to start saving your money!",
    buttonText: "Signup",
  };
  const handleConfirmationModalToggle = (id) => {
    setIsConfirmationModalOpen(!isConfirmationModalOpen);
  };
  const gotoSignup = () => {
    if (type === "login") {
      setIsSwapped(!isSwapped);
      setSearchParams({ type: "signup" });
      navigate("/auth?type=signup");
    }
  };
  useEffect(() => {
    const { appVerifier, error } = firebaseRecaptchaVerifier();
    setAppVerifier(appVerifier);
    if (error) {
      showToast(error, "error", true);
    }
  }, []);

  const handlePhoneChange = (value) => {
    setPhone(value);
    setPhoneError("");
  };

  const validateForm = () => {
    if (!phone || !isValidPhoneNumber(phone)) {
      setPhoneError("Please enter a valid phone number");
      return false;
    }
    return true;
  };

  const getOtp = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    try {
      const checkUserExists = await checkUserExistsApi(
        user?.accessToken,
        phone,
        selectedStore?.isWhiteLabel,
        selectedStore?.id,
        formData?.email ? formData.email : null
      );

      if ('success' in checkUserExists && !checkUserExists.success) {
        setLoading(true);
        const confirmationResult = await signInWithPhoneNumber(
          auth,
          phone,
          appVerifier
        );
      
        setFormData({
          firstName: checkUserExists?.message?.user?.first_name,
          lastName: checkUserExists?.message?.user?.last_name,
          email: checkUserExists?.message?.user?.email,
        });

        if (confirmationResult) {
         
          dispatch(
            setOtpData({
              result: confirmationResult,
              formData,
              phone: phone,
            })
          );
          navigate("/auth/verify?type=login");
          showToast("OTP sent successfully", "success", true);
          setLoading(false);
        }
      } else {
        setIsConfirmationModalOpen(true);
      }
    } catch (err) {
      console.error("Error sending OTP:", err);
      showToast(err.message, "error", true);
    }
  };

  return (
    <div className="lg:w-[85%] md:w-full w-full p-8 sm:shadow-none lg:shadow-none  md:shadow-gray-shadow   ">
      <form onSubmit={getOtp} className="space-y-3">
        <div className="mx-auto h-44 w-44">
          <img
            src={
              !selectedStore?.isWhiteLabel
                ? loginMav
                : selectedStore?.isWhiteLabel &&
                  selectedStore.name === MAVENCERY_STORES_NAMES.AlHalalMeats
                ? loginAlHalal
                : loginMav
            }
            alt="loginAlt"
          />
        </div>
        <p
          className={`font-bold text-center  ${
            !selectedStore?.isWhiteLabel
              ? "text-theme-color"
              : selectedStore?.isWhiteLabel &&
                selectedStore.name === MAVENCERY_STORES_NAMES.AlHalalMeats
              ? "text-orangeColor"
              : "text-gray-800"
          } `}
        >
          Sign in with your phone number
        </p>
        <div className="w-full mt-4 bg-white border border-gray-400 rounded-md">
          <CustomPhoneInput
            phone={phone}
            handlePhoneChange={handlePhoneChange}
          />
        </div>
        {phoneError && (
          <div>
            <p className="mt-1 text-xs text-red-300">{phoneError}</p>
          </div>
        )}
        <div>
          <button
            disabled={loading}
            style={{
              backgroundColor: loading
                ? "lightGray"
                : selectedStore?.theme.backgroundColor,
            }}
            type="submit"
            className={`w-full px-4 py-2 mt-4 mb-2 text-sm text-white transition duration-300 rounded-md`}
          >
            Request OTP
          </button>
        </div>
        <div
          className="w-full lg:hidden md:inline-block sm:inline-block"
          onClick={gotoSignup}
        >
          <button className="w-full px-4 py-2 mb-2 text-sm text-white transition duration-300 bg-red-500 rounded-md ">
            Don't have an account?
          </button>
        </div>
      </form>
      <div id="recaptcha-container"></div>
      {isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={isConfirmationModalOpen}
          onClose={handleConfirmationModalToggle}
          modalData={modalData}
          handleSubmit={gotoSignup}
        />
      )}
    </div>
  );
};

export default Login;
